<mat-accordion>
  <mat-expansion-panel
    class="expension-pannel"
    hideToggle
    ngModel
    (opened)="query.panelOpenState = true"
    (closed)="query.panelOpenState = false"
  >
    <mat-expansion-panel-header>
      <mat-panel-description>
        {{ query.question }}
        <mat-icon class="not-translate" *ngIf="!query.panelOpenState" style="text-align: end;"
          >add_circle_outline</mat-icon
        >
        <mat-icon class="not-translate" *ngIf="query.panelOpenState" style="text-align: end;"
          >remove_circle_outline</mat-icon
        >
      </mat-panel-description>
    </mat-expansion-panel-header>
    <p [innerHTML]="query.answer | safeHtml: 'html'"></p>
  </mat-expansion-panel>
</mat-accordion>
